import { FC, ReactNode, Suspense } from 'react';

import { CommonSuspenseFallback } from './common-suspense-fallback.tsx';

interface Props {
  children: ReactNode;
  fitContent?: boolean;
}

export const CommonSuspense: FC<Props> = ({ children, fitContent }) => {
  return <Suspense fallback={<CommonSuspenseFallback fitContent={fitContent} />}>{children}</Suspense>;
};
